// Comment of a query line of the audit trail. The server stores it as `comment` on a
// transition, but as `current_comment` on the creation (the field sent by QueryModal,
// DOQBOARD-303).
export const getQueryAuditComment = (details) => (
  details ? details.comment || details.current_comment || '' : ''
);

export default getQueryAuditComment;
